<template>
  <v-container fluid pa-0>
    <v-flex xs12 style="font-size: 36px; font-weight: 700">
      Notifications
    </v-flex>
    <v-card class="elevation-0" secondary style="display: flex; align-items: center; justify-content: center; padding: 60px 20%; flex: none; flex-direction: column; margin-top: 60px">
      <v-form>
        <v-layout row>
          <v-flex style="font-size: 24px; font-weight: 700; width: 400px">Organization</v-flex>
          <v-flex style="font-size: 18px; font-weight: 700; width: 90px">Email</v-flex>

        </v-layout>
        <v-layout row style="margin-top: 30px">
          <v-flex style="font-size: 18px; width: 400px">Project Creation Approved</v-flex>
          <v-flex style="width: 90px"><v-checkbox disabled :ripple="false" color="primary" class="ml-1 mt-0" v-model="projectCreationApproval"></v-checkbox></v-flex>
        </v-layout>
        <v-layout row style="margin-top: 20px">
          <v-flex style="font-size: 18px; width: 400px">Project Updated</v-flex>
          <v-flex style="width: 90px"><v-checkbox disabled :ripple="false" color="primary" class="ml-1 mt-0" v-model="projectUpdated"></v-checkbox></v-flex>
        </v-layout>
        <v-layout row style="margin-top: 20px">
          <v-flex style="font-size: 18px; width: 400px">Payment Receipts</v-flex>
          <v-flex style="width: 90px"><v-checkbox disabled :ripple="false" color="primary" class="ml-1 mt-0 paymentReceiptsEmail" v-model="paymentReceipts"></v-checkbox></v-flex>
        </v-layout>
        <v-layout row style="margin-top: 60px">
          <v-flex style="font-size: 24px; font-weight: 700; width: 350px">Requests</v-flex>
        </v-layout>
        <v-layout row style="margin-top: 30px">
          <v-flex style="font-size: 18px; width: 400px">Project Subscription Request</v-flex>
          <v-flex style="width: 90px"><v-checkbox disabled :ripple="false" color="primary" class="ml-1 mt-0" v-model="projectSubscriptionRequest"></v-checkbox></v-flex>
        </v-layout>
        <v-layout row style="margin-top: 20px">
          <v-flex style="font-size: 18px; width: 400px">Project Access Request</v-flex>
          <v-flex style="width: 90px"><v-checkbox disabled :ripple="false" color="primary" class="ml-1 mt-0" v-model="projectAccessRequest"></v-checkbox></v-flex>
        </v-layout>
        <v-layout row style="margin-top: 20px">
          <v-flex style="font-size: 18px; width: 400px">Project Creation Request</v-flex>
          <v-flex style="width: 90px"><v-checkbox disabled :ripple="false" color="primary" class="ml-1 mt-0" v-model="projectCreationRequest"></v-checkbox></v-flex>
        </v-layout>
        <v-layout row style="margin-top: 60px">
          <v-flex style="font-size: 24px; font-weight: 700; width: 350px">Yakshof Market</v-flex>
        </v-layout>
        <v-layout row style="margin-top: 30px">
          <v-flex style="font-size: 18px; width: 400px">Yakshof Market Weekly Digest</v-flex>
          <v-flex style="width: 90px"><v-checkbox disabled :ripple="false" color="primary" class="ml-1 mt-0" v-model="weeklyDigest"></v-checkbox></v-flex>
        </v-layout>
        <v-layout row style="margin-top: 20px">
          <v-flex style="font-size: 18px; width: 400px">Yakshof Market Tips</v-flex>
          <v-flex style="width: 90px"><v-checkbox disabled :ripple="false" color="primary" class="ml-1 mt-0" v-model="marketTips"></v-checkbox></v-flex>
        </v-layout>
        <div style="text-align: center">
          <v-btn disabled large round class="primary secondary--text mt-4" :ripple="false" style="width: 180px;height: 45px;">Save</v-btn>
        </div>
      </v-form>
    </v-card>
  </v-container>
</template>

<style>
  .paymentReceiptsEmail.theme--light.v-input--selection-controls.v-input--is-disabled .v-icon{
    color: #B2BBC5 !important;
  }
</style>

<script>
export default{
  data () {
    return {
      projectCreationApproval: true,
      projectUpdated: true,
      paymentReceipts: true,
      projectSubscriptionRequest: true,
      projectAccessRequest: true,
      projectCreationRequest: true,
      weeklyDigest: true,
      marketTips: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings/Notifications.vue